module.exports = __webpack_public_path__ + "img/1.cfc7bdf.svg";